import { useContext } from 'react';
import { ManagerProfileContext } from './ManagerProfileContext';

const useManagerProfile = () => {
    const context = useContext(ManagerProfileContext);

    if (context === undefined) throw new Error('useManagerProfile must be used within a ManagerProfileProvider');

    return context;
};

export default useManagerProfile;
